import {  importProvidersFrom,InjectionToken } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {environment as local} from 'src/environments/environment';
import {environment as dev} from 'src/environments/environment.dev';
import {environment as qa} from 'src/environments/environment.qa';
import {environment as prod} from 'src/environments/environment.prod';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';

declare var window: any;
 
export const environments: Record<string, EnvironmentConfigurationSettings> = {
  default: local,
  dev: dev,
  prod: prod,
  qa: qa
};
 
export const environment1=local;
export interface EnvironmentConfigurationSettings {
  [setting: string]: any;
 
}
 
export interface EnvironmentConfigurations {
  default: EnvironmentConfigurationSettings;
  [environment: string]: EnvironmentConfigurationSettings;
}
export const Environments = new InjectionToken<EnvironmentConfigurations>('Environments');
 
   const hostname = window.location?.hostname?.toLowerCase() ?? null;
   
 
   let environmentType = environments.default;
   
    const environmentNames: string[] = Object.keys(environments).filter(envName => envName !== 'default');
    let selectedEnvName = environmentNames.find(envName => {
     
      if (environments[envName]?.hostname) {
        return environments[envName].hostname.toLowerCase() === hostname;
      } else {
        return false;
      }
    });


    // Override default behavior by setting window.environment in index.html
    if (window['environment'] && environments[window['environment']]) {
      selectedEnvName = window['environment'];
    }
 
   
   // selectedEnvName="dev"
    if (!selectedEnvName) {
      selectedEnvName = 'default';
    } else if (selectedEnvName && environments[selectedEnvName]) {
      environmentType = environments[selectedEnvName];
    }
    console.info("environmentType, line 74", environmentType);
   
    environmentType.envName = selectedEnvName;
 
    Object.assign(environment1, environmentType);
    Object.assign(local, environmentType);

void (async () => {
  try {
    await bootstrapApplication(AppComponent, {
      providers: [importProvidersFrom(AppModule)]
    });
  } catch (err) {
    console.trace(err);
  }
})();
 